// leaf-town - audio: a small synth, a pattern sequencer, sound effects and voice playback
(function () {
  'use strict';
  const G = window.G;
  const A = (G.audio = { ctx: null, muted: false, intensity: 0, current: null });
  let ctx = null, master, comp, musicBus, sfxBus, voiceBus, revIn, dlyIn, delay, noiseBuf;
  const waves = {};
  let duckAmt = 1, player = null;

  // ---------- setup ----------
  function init() {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = A.ctx = new AC();
    graph();
    A.applyVolume();
    setInterval(tick, 30);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) ctx.suspend(); else if (!A.paused) ctx.resume();
    });
    if (A.pending) { const p = A.pending; A.pending = null; A.music(p); }
  }
  function graph() {
    comp = ctx.createDynamicsCompressor();
    comp.threshold.value = -16; comp.knee.value = 20; comp.ratio.value = 4; comp.attack.value = 0.004; comp.release.value = 0.2;
    master = ctx.createGain(); master.gain.value = 0.85;
    master.connect(comp); comp.connect(ctx.destination);
    musicBus = ctx.createGain(); sfxBus = ctx.createGain();
    musicBus.connect(master); sfxBus.connect(master);
    voiceBus = ctx.createGain(); voiceBus.connect(master);
    // reverb from a decaying noise impulse
    const len = Math.floor(ctx.sampleRate * 2.1), ir = ctx.createBuffer(2, len, ctx.sampleRate);
    for (let ch = 0; ch < 2; ch++) {
      const d = ir.getChannelData(ch);
      for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.8) * (i < 400 ? i / 400 : 1);
    }
    const conv = ctx.createConvolver(); conv.buffer = ir;
    const revOut = ctx.createGain(); revOut.gain.value = 0.55;
    revIn = ctx.createGain(); revIn.connect(conv); conv.connect(revOut); revOut.connect(master);
    // feedback delay
    delay = ctx.createDelay(1.5); delay.delayTime.value = 0.33;
    const fb = ctx.createGain(); fb.gain.value = 0.36;
    const lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 2400;
    const dlyOut = ctx.createGain(); dlyOut.gain.value = 0.6;
    dlyIn = ctx.createGain(); dlyIn.connect(delay); delay.connect(lp); lp.connect(fb); fb.connect(delay); lp.connect(dlyOut); dlyOut.connect(master);
    // noise
    noiseBuf = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
    const nd = noiseBuf.getChannelData(0);
    for (let i = 0; i < nd.length; i++) nd[i] = Math.random() * 2 - 1;
    // narrow pulse waves
    for (const duty of [0.125, 0.25]) {
      const n = 32, re = new Float32Array(n), im = new Float32Array(n);
      for (let k = 1; k < n; k++) re[k] = (2 / (k * Math.PI)) * Math.sin(k * Math.PI * duty);
      waves['pulse' + duty * 1000] = ctx.createPeriodicWave(re, im);
    }
  }
  A.unlock = () => {
    if (!ctx) init();
    if (ctx && ctx.state === 'suspended' && !document.hidden) ctx.resume();
  };
  A.applyVolume = () => {
    if (!ctx) return;
    const o = G.save.data.opt, m = A.muted ? 0 : 1;
    musicBus.gain.setTargetAtTime(o.music * duckAmt * m, ctx.currentTime, 0.08);
    sfxBus.gain.setTargetAtTime(o.sfx * 2.6 * m, ctx.currentTime, 0.02);
    voiceBus.gain.setTargetAtTime(o.voice * m, ctx.currentTime, 0.02);
    if (G.voice && G.voice.cur && G.voice.cur.el) G.voice.cur.el.volume = A.muted ? 0 : Math.min(1, o.voice);
  };
  A.toggleMute = () => { A.muted = !A.muted; A.applyVolume(); };
  A.duck = (amt) => { duckAmt = amt; A.applyVolume(); };

  // ---------- instruments ----------
  const INST = {
    lead: { wave: 'pulse250', a: 0.006, d: 0.14, s: 0.62, r: 0.1, vol: 0.2, vib: 6, vibDelay: 0.16, rev: 0.18, dly: 0.22 },
    thin: { wave: 'pulse125', a: 0.004, d: 0.1, s: 0.6, r: 0.08, vol: 0.25, vib: 5, vibDelay: 0.2, rev: 0.15, dly: 0.28 },
    square: { wave: 'square', a: 0.004, d: 0.12, s: 0.55, r: 0.08, vol: 0.12, rev: 0.12, dly: 0.15 },
    soft: { wave: 'triangle', a: 0.01, d: 0.2, s: 0.7, r: 0.16, vol: 0.26, vib: 4, vibDelay: 0.25, rev: 0.3, dly: 0.2 },
    bell: { wave: 'sine', fm: { ratio: 3.5, idx: 2.2, decay: 0.09 }, a: 0.002, d: 0.5, s: 0, r: 0.5, vol: 0.25, rev: 0.45, dly: 0.34, ring: 1 },
    glass: { wave: 'sine', fm: { ratio: 2, idx: 1.2, decay: 0.2 }, a: 0.004, d: 0.9, s: 0, r: 0.7, vol: 0.18, rev: 0.6, dly: 0.4, ring: 1 },
    pluck: { wave: 'sawtooth', filt: { f: 700, env: 2600, dec: 0.045, q: 2 }, a: 0.002, d: 0.14, s: 0, r: 0.08, vol: 0.17, rev: 0.16, dly: 0.12, ring: 1 },
    chip: { wave: 'pulse125', a: 0.002, d: 0.08, s: 0.15, r: 0.05, vol: 0.15, rev: 0.1, dly: 0.1 },
    pad: { wave: 'sawtooth', voices: 2, det: 14, filt: { f: 850, q: 0.6 }, a: 0.3, d: 0.4, s: 0.8, r: 0.6, vol: 0.055, rev: 0.5 },
    organ: { wave: 'square', filt: { f: 1600, q: 0.8 }, a: 0.005, d: 0.08, s: 0.5, r: 0.05, vol: 0.08, rev: 0.2 },
    stab: { wave: 'sawtooth', voices: 2, det: 10, filt: { f: 900, env: 2400, dec: 0.07, q: 3 }, a: 0.003, d: 0.12, s: 0.2, r: 0.08, vol: 0.09, rev: 0.25 },
    bass: { wave: 'triangle', a: 0.004, d: 0.1, s: 0.8, r: 0.05, vol: 0.25 },
    sbass: { wave: 'sawtooth', filt: { f: 260, env: 1300, dec: 0.07, q: 5 }, a: 0.003, d: 0.12, s: 0.7, r: 0.05, vol: 0.2 },
    sub: { wave: 'sine', a: 0.02, d: 0.2, s: 0.9, r: 0.2, vol: 0.19 },
  };
  A.INST = INST;
  function setWave(o, w) { if (waves[w]) o.setPeriodicWave(waves[w]); else o.type = w; }
  const mtof = (m) => 440 * Math.pow(2, (m - 69) / 12);

  function note(I, dest, m, t, dur, vel) {
    const f = mtof(m), peak = I.vol * (vel || 1);
    if (I.ring) dur = Math.max(dur, 0.05);
    dur = Math.max(dur, I.a + 0.015);
    const end = t + dur + I.r * 3 + 0.05;
    const out = ctx.createGain();
    out.gain.setValueAtTime(0.0001, t);
    out.gain.linearRampToValueAtTime(peak, t + I.a);
    out.gain.setTargetAtTime(peak * I.s, t + I.a, I.d / 3);
    out.gain.setTargetAtTime(0.0001, t + dur, I.r / 2.5);
    let tail = out;
    if (I.filt) {
      const fl = ctx.createBiquadFilter();
      fl.type = 'lowpass'; fl.Q.value = I.filt.q || 1;
      if (I.filt.env) { fl.frequency.setValueAtTime(I.filt.f + I.filt.env, t); fl.frequency.setTargetAtTime(I.filt.f, t, I.filt.dec); }
      else fl.frequency.value = I.filt.f;
      fl.connect(out); tail = fl;
    }
    const n = I.voices || 1;
    let lfoGain = null;
    if (I.vib && dur > I.vibDelay + 0.05) {
      const lfo = ctx.createOscillator(); lfo.frequency.value = 5.6;
      lfoGain = ctx.createGain();
      lfoGain.gain.setValueAtTime(0, t + I.vibDelay);
      lfoGain.gain.linearRampToValueAtTime(I.vib * 2.2, t + I.vibDelay + 0.2);
      lfo.connect(lfoGain); lfo.start(t); lfo.stop(end);
    }
    for (let i = 0; i < n; i++) {
      const o = ctx.createOscillator();
      setWave(o, I.wave);
      o.frequency.value = f;
      o.detune.value = n > 1 ? (i - (n - 1) / 2) * I.det : 0;
      if (lfoGain) lfoGain.connect(o.detune);
      if (I.fm && i === 0) {
        const mod = ctx.createOscillator(), mg = ctx.createGain();
        mod.frequency.value = f * I.fm.ratio;
        mg.gain.setValueAtTime(f * I.fm.idx, t); mg.gain.setTargetAtTime(f * I.fm.idx * 0.08, t, I.fm.decay);
        mod.connect(mg); mg.connect(o.frequency); mod.start(t); mod.stop(end);
      }
      o.connect(tail); o.start(t); o.stop(end);
    }
    out.connect(dest);
  }

  function nz(t, dur, vol, type, f0, f1, q, dest) {
    const s = ctx.createBufferSource(); s.buffer = noiseBuf; s.loop = true;
    const fl = ctx.createBiquadFilter(); fl.type = type; fl.Q.value = q || 0.8;
    fl.frequency.setValueAtTime(Math.max(30, f0), t);
    if (f1) fl.frequency.exponentialRampToValueAtTime(Math.max(30, f1), t + dur);
    const g = ctx.createGain();
    g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0008, t + dur);
    s.connect(fl); fl.connect(g); g.connect(dest);
    s.start(t, Math.random() * 1.5); s.stop(t + dur + 0.02);
  }
  function tn(t, type, f0, f1, dur, vol, dest, a) {
    const o = ctx.createOscillator(); setWave(o, type);
    o.frequency.setValueAtTime(Math.max(20, f0), t);
    if (f1 && f1 !== f0) o.frequency.exponentialRampToValueAtTime(Math.max(20, f1), t + dur);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(vol, t + (a || 0.003));
    g.gain.exponentialRampToValueAtTime(0.0008, t + dur);
    o.connect(g); g.connect(dest); o.start(t); o.stop(t + dur + 0.02);
  }
  function drum(k, t, v, dest) {
    switch (k) {
      case 'k': tn(t, 'sine', 160, 42, 0.2, 0.85 * v, dest); nz(t, 0.02, 0.2 * v, 'lowpass', 2500, 0, 0.7, dest); break;
      case 's': nz(t, 0.15, 0.36 * v, 'bandpass', 2100, 1400, 0.6, dest); tn(t, 'triangle', 210, 130, 0.09, 0.3 * v, dest); break;
      case 'h': nz(t, 0.035, 0.13 * v, 'highpass', 7800, 0, 0.8, dest); break;
      case 'o': nz(t, 0.19, 0.12 * v, 'highpass', 7000, 0, 0.8, dest); break;
      case 'c': for (let i = 0; i < 3; i++) nz(t + i * 0.011, 0.07, 0.2 * v, 'bandpass', 1300, 0, 1.4, dest); break;
      case 'r': tn(t, 'triangle', 1750, 1750, 0.03, 0.2 * v, dest); nz(t, 0.02, 0.1 * v, 'bandpass', 3200, 0, 2, dest); break;   // rim
      case 't': tn(t, 'sine', 2100, 2000, 0.03, 0.16 * v, dest); break;   // tick
      case 'T': tn(t, 'sine', 1400, 1350, 0.035, 0.16 * v, dest); break;  // tock
      case 'm': tn(t, 'sine', 230, 110, 0.18, 0.45 * v, dest); break;     // tom
      case 'C': nz(t, 0.9, 0.2 * v, 'highpass', 4200, 0, 0.5, dest); break; // crash
    }
  }

  // ---------- song compiler ----------
  const NOTE = { c: 0, d: 2, e: 4, f: 5, g: 7, a: 9, b: 11 };
  function parseNote(s) {
    const m = /^([a-g])([#b]?)(\d)$/.exec(s);
    if (!m) return null;
    return 12 * (parseInt(m[3], 10) + 1) + NOTE[m[1]] + (m[2] === '#' ? 1 : m[2] === 'b' ? -1 : 0);
  }
  const QUAL = { '': [0, 4, 7], m: [0, 3, 7], 7: [0, 4, 7, 10], m7: [0, 3, 7, 10], maj7: [0, 4, 7, 11], sus4: [0, 5, 7], sus2: [0, 2, 7], dim: [0, 3, 6], add9: [0, 4, 7, 14], m9: [0, 3, 7, 14], 5: [0, 7, 12] };
  function parseChord(s) {
    const m = /^([A-G])([#b]?)([a-z0-9]*)(?:\/([A-G])([#b]?))?$/.exec(s);
    if (!m) { console.warn('bad chord', s); return { root: 0, tones: QUAL[''], bass: 0 }; }
    const root = NOTE[m[1].toLowerCase()] + (m[2] === '#' ? 1 : m[2] === 'b' ? -1 : 0);
    const bass = m[4] ? NOTE[m[4].toLowerCase()] + (m[5] === '#' ? 1 : m[5] === 'b' ? -1 : 0) : root;
    return { root: (root + 12) % 12, tones: QUAL[m[3]] || QUAL[''], bass: (bass + 12) % 12 };
  }
  function compileSection(sec, song) {
    const bars = sec.bars, ev = [];
    for (let b = 0; b < bars; b++) { ev.push([]); for (let s = 0; s < 16; s++) ev[b].push([]); }
    const chordBars = (sec.chords || 'C').split('|').map((x) => x.trim().split(/\s+/).map(parseChord));
    const chordAt = (pos) => {
      const cb = chordBars[Math.floor(pos / 16) % chordBars.length];
      return cb[Math.min(cb.length - 1, Math.floor(((pos % 16) / 16) * cb.length))];
    };
    const put = (pos, e) => { if (pos < bars * 16) ev[Math.floor(pos / 16)][pos % 16].push(e); };
    for (const tr in sec) {
      if (tr === 'bars' || tr === 'chords' || tr === 'drums' || tr === 'fill') continue;
      let spec = sec[tr];
      if (typeof spec === 'string') spec = { n: spec };
      const hi = spec.hi ? 1 : 0, v = spec.v || 1;
      const inst = spec.inst || (song.inst && song.inst[tr]) || tr;
      const u = spec.u || (spec.n ? 2 : 1);
      const total = bars * 16;
      if (spec.n) {                               // written melody
        const toks = spec.n.replace(/\|/g, ' ').trim().split(/\s+/);
        if (toks.length !== total / u) console.warn('song track "' + tr + '" has ' + toks.length + ' steps, expected ' + total / u);
        let last = null;
        toks.forEach((tk, i) => {
          const pos = i * u;
          if (tk === '-') { if (last) last.len += u; return; }
          if (tk === '.') { last = null; return; }
          const m = parseNote(tk);
          if (m === null) { console.warn('bad note', tk, 'in', tr); return; }
          last = { tr, inst, m: m + (spec.oct || 0) * 12, len: u, v, hi };
          put(pos, last);
        });
      } else if (spec.bass) {                     // pattern in chord degrees
        const toks = spec.bass.trim().split(/\s+/);
        let last = null;
        for (let pos = 0, i = 0; pos < total; pos += u, i++) {
          const tk = toks[i % toks.length], c = chordAt(pos);
          if (tk === '-') { if (last) last.len += u; continue; }
          if (tk === '.') { last = null; continue; }
          let base = 36 + c.bass; if (c.bass >= 9) base -= 12;
          const third = c.tones[1], sev = c.tones[3] !== undefined ? c.tones[3] : 10;
          const off = tk === '1' ? 0 : tk === '3' ? third : tk === '5' ? 7 : tk === '7' ? sev : tk === '8' ? 12 : tk === '4' ? 5 : 0;
          last = { tr, inst, m: base + (c.bass === c.root || tk === '1' || tk === '8' ? off : 0) + (spec.oct || 0) * 12, len: u, v, hi };
          put(pos, last);
        }
      } else if (spec.arp) {                      // chord tone indices
        const toks = spec.arp.trim().split(/\s+/);
        for (let pos = 0, i = 0; pos < total; pos += u, i++) {
          const tk = toks[i % toks.length], c = chordAt(pos);
          if (tk === '.' || tk === '-') continue;
          const k = parseInt(tk, 10), n = c.tones.length;
          const m = 12 * ((spec.oct || 4) + 1) + c.root + c.tones[k % n] + 12 * Math.floor(k / n);
          put(pos, { tr, inst, m, len: spec.len || u, v, hi });
        }
      } else if (spec.pad) {                      // held chords
        for (let b = 0; b < bars; b++) {
          const cb = chordBars[b % chordBars.length], each = 16 / cb.length;
          cb.forEach((c, ci) => c.tones.slice(0, 4).forEach((iv) => {
            let m = 12 * ((spec.oct || 3) + 1) + c.root + iv;
            if (m > 12 * ((spec.oct || 3) + 1) + 16) m -= 12;
            put(b * 16 + ci * each, { tr, inst, m, len: each, v, hi });
          }));
        }
      } else if (spec.stab) {                     // rhythmic chord hits
        const pat = spec.stab.replace(/\s+/g, '');
        for (let pos = 0; pos < total; pos += u) {
          const ch = pat[(pos / u) % pat.length];
          if (ch !== 'x' && ch !== 'X') continue;
          const c = chordAt(pos);
          c.tones.slice(0, 3).forEach((iv) => put(pos, { tr, inst, m: 12 * ((spec.oct || 4) + 1) + c.root + iv, len: spec.len || u, v: v * (ch === 'X' ? 1.25 : 1), hi }));
        }
      }
    }
    const drums = (set, lastBarOnly, hi) => {
      for (const k in set) {
        if (k === 'hi') continue;
        const pat = set[k].replace(/[\s|]+/g, '');
        if (!pat.length) continue;
        for (let b = lastBarOnly ? bars - 1 : 0; b < bars; b++) {
          if (!lastBarOnly && sec.fill && b === bars - 1 && sec.fill[k] !== undefined) continue;
          for (let s = 0; s < 16; s++) {
            const ch = pat[lastBarOnly ? s % pat.length : (b * 16 + s) % pat.length];
            if (ch === 'x') ev[b][s].push({ d: k, v: 0.8, hi });
            else if (ch === 'X') ev[b][s].push({ d: k, v: 1, hi });
            else if (ch === 'o') ev[b][s].push({ d: k, v: 0.4, hi });
          }
        }
      }
    };
    if (sec.drums) { drums(sec.drums, false, 0); if (sec.drums.hi) drums(sec.drums.hi, false, 1); }
    if (sec.fill) drums(sec.fill, true, 0);
    return { bars, ev };
  }
  function compile(song) {
    if (song._c) return song._c;
    const c = {};
    for (const name in song.sections) c[name] = compileSection(song.sections[name], song);
    return (song._c = c);
  }

  // ---------- sequencer ----------
  function strip(p, tr, I) {
    let s = p.strips[tr];
    if (!s) {
      s = p.strips[tr] = ctx.createGain();
      s.connect(p.gain);
      if (I.rev) { const r = ctx.createGain(); r.gain.value = I.rev; s.connect(r); r.connect(p.rev); }
      if (I.dly) { const d = ctx.createGain(); d.gain.value = I.dly; s.connect(d); d.connect(p.dly); }
    }
    return s;
  }
  function stepOnce(p) {
    const sec = p.c[p.song.order[p.order]];
    const t = p.t + (p.step & 1 ? p.stepDur * (p.song.swing || 0) : 0);
    for (const e of sec.ev[p.bar][p.step]) {
      if (e.hi && A.intensity < 1) continue;
      if (A._solo && A._solo !== (e.d ? 'drums' : e.tr)) continue;
      if (e.d) drum(e.d, t, e.v * (p.song.drumVol || 1), p.drums);
      else {
        const I = typeof e.inst === 'string' ? INST[e.inst] || INST.lead : e.inst;
        note(I, strip(p, e.tr, I), e.m, t, e.len * p.stepDur * (I.ring ? 1 : 0.92), e.v);
      }
    }
    p.t += p.stepDur;
    if (++p.step >= 16) {
      p.step = 0;
      if (++p.bar >= sec.bars) {
        p.bar = 0;
        if (++p.order >= p.song.order.length) {
          if (p.song.once) { p.done = true; if (p.onEnd) setTimeout(p.onEnd, Math.max(0, (p.t - ctx.currentTime) * 1000)); }
          else p.order = p.song.loop || 0;
        }
      }
    }
  }
  function tick() {
    const p = player;
    if (!p || !ctx || ctx.state !== 'running') return;
    if (p.t < ctx.currentTime - 0.3) p.t = ctx.currentTime + 0.05;   // woke up after a stall
    while (p.t < ctx.currentTime + 0.16 && !p.done) stepOnce(p);
  }
  // dev tool: render a song offline and report levels (used to balance the mix without ears)
  A.renderOffline = async (name, secs, solo) => {
    const keep = [ctx, master, comp, musicBus, sfxBus, voiceBus, revIn, dlyIn, delay, noiseBuf, player, A.current];
    const keepWaves = Object.assign({}, waves);
    const oc = new OfflineAudioContext(2, Math.floor(44100 * secs), 44100);
    ctx = oc; graph();
    musicBus.gain.value = 0.7; sfxBus.gain.value = 0.8 * 2.6;
    player = null; A._solo = solo || null;
    let res;
    if (name.startsWith('sfx:')) { const n = name.slice(4), d = ctx.createGain(); d.gain.value = TRIM[n] || 1; d.connect(sfxBus); SFX[n](0.01, d, {}); }
    else { A.music(name); const p = player; while (p.t < secs && !p.done) stepOnce(p); }
    const buf = await oc.startRendering();
    const d = buf.getChannelData(0);
    let peak = 0, sum = 0;
    for (let i = 0; i < d.length; i++) { const v = Math.abs(d[i]); if (v > peak) peak = v; sum += v * v; }
    res = { peak: +peak.toFixed(3), rms: +Math.sqrt(sum / d.length).toFixed(4) };
    A._solo = null;
    [ctx, master, comp, musicBus, sfxBus, voiceBus, revIn, dlyIn, delay, noiseBuf, player, A.current] = keep;
    Object.assign(waves, keepWaves);
    return res;
  };
  function stopPlayer(p, fade) {
    if (!p) return;
    p.done = true;
    const t = ctx.currentTime;
    p.gain.gain.cancelScheduledValues(t);
    p.gain.gain.setTargetAtTime(0, t, Math.max(0.01, fade / 3));
    setTimeout(() => { try { p.gain.disconnect(); p.rev.disconnect(); p.dly.disconnect(); } catch (e) { /* gone */ } }, fade * 1000 + 2500);
  }
  // start a song (no-op if it is already playing). opts: {fade, onEnd, restart}
  A.music = (name, opts) => {
    opts = opts || {};
    if (!ctx) { A.pending = name; A.current = name; return; }
    if (player && !player.done && player.name === name && !opts.restart) return;
    stopPlayer(player, opts.fade === undefined ? 0.5 : opts.fade);
    player = null; A.current = name;
    const song = name && G.SONGS[name];
    if (!song) return;
    const p = { name, song, c: compile(song), strips: {}, order: 0, bar: 0, step: 0, done: false, onEnd: opts.onEnd };
    p.stepDur = 60 / song.bpm / 4;
    p.gain = ctx.createGain(); p.gain.gain.value = song.vol || 1; p.gain.connect(musicBus);
    p.drums = ctx.createGain(); p.drums.gain.value = 0.62; p.drums.connect(p.gain);
    p.rev = ctx.createGain(); p.rev.connect(revIn);
    p.dly = ctx.createGain(); p.dly.connect(dlyIn);
    delay.delayTime.setValueAtTime(Math.min(1.2, (60 / song.bpm) * 0.75), ctx.currentTime);
    p.t = ctx.currentTime + (opts.delay || 0.08);
    player = p;
  };
  A.stopMusic = (fade) => { if (ctx) { stopPlayer(player, fade === undefined ? 0.6 : fade); player = null; } A.current = null; A.pending = null; };

  // ---------- sound effects ----------
  const last = {};
  let tokenChain = 0, tokenT = 0;
  const SFX = {
    jump: (t, d) => { tn(t, 'pulse250', 300, 640, 0.13, 0.16, d); },
    djump: (t, d) => { tn(t, 'pulse125', 520, 1100, 0.12, 0.15, d); nz(t, 0.1, 0.1, 'bandpass', 1800, 600, 1, d); },
    walljump: (t, d) => { tn(t, 'pulse250', 380, 760, 0.11, 0.15, d); nz(t, 0.05, 0.12, 'lowpass', 900, 0, 1, d); },
    land: (t, d) => { nz(t, 0.07, 0.2, 'lowpass', 520, 200, 0.8, d); },
    swipe: (t, d) => { nz(t, 0.1, 0.3, 'bandpass', 2600, 500, 1.3, d); tn(t, 'triangle', 900, 260, 0.07, 0.07, d); },
    swipeBig: (t, d) => { nz(t, 0.14, 0.36, 'bandpass', 3200, 380, 1.1, d); tn(t, 'sawtooth', 1200, 200, 0.1, 0.07, d); },
    hit: (t, d) => { nz(t, 0.09, 0.4, 'lowpass', 2600, 300, 0.8, d); tn(t, 'square', 240, 70, 0.09, 0.2, d); },
    clang: (t, d) => { tn(t, 'square', 1500, 1420, 0.07, 0.1, d); tn(t, 'triangle', 2260, 2200, 0.12, 0.12, d); },
    squish: (t, d) => { tn(t, 'sine', 420, 70, 0.12, 0.34, d); nz(t, 0.08, 0.22, 'lowpass', 1200, 200, 1, d); tn(t + 0.05, 'sine', 700, 1500, 0.06, 0.14, d); },
    kill: (t, d) => { tn(t, 'square', 330, 60, 0.14, 0.2, d); nz(t, 0.14, 0.34, 'lowpass', 3000, 250, 0.8, d); tn(t + 0.04, 'pulse125', 880, 1760, 0.07, 0.1, d); },
    hurt: (t, d) => { tn(t, 'sawtooth', 440, 90, 0.28, 0.24, d); nz(t, 0.16, 0.3, 'lowpass', 1800, 200, 0.8, d); },
    die: (t, d) => { [660, 520, 392, 262, 196].forEach((f, i) => tn(t + i * 0.085, 'pulse250', f, f * 0.94, 0.12, 0.18, d)); nz(t, 0.5, 0.3, 'lowpass', 2400, 120, 0.7, d); },
    token: (t, d) => {
      const n = Math.min(tokenChain, 9), f = 988 * Math.pow(2, n / 12);
      tn(t, 'pulse250', f, f, 0.05, 0.1, d); tn(t + 0.045, 'pulse250', f * 1.335, f * 1.335, 0.1, 0.1, d);
    },
    spark: (t, d) => { [1047, 1319, 1568, 2093, 2637].forEach((f, i) => { tn(t + i * 0.06, 'sine', f, f, 0.3, 0.15, d); tn(t + i * 0.06, 'triangle', f * 2, f * 2, 0.12, 0.05, d); }); },
    heal: (t, d) => { tn(t, 'triangle', 523, 523, 0.1, 0.25, d); tn(t + 0.08, 'triangle', 784, 784, 0.16, 0.25, d); tn(t + 0.16, 'triangle', 1047, 1047, 0.2, 0.2, d); },
    dash: (t, d) => { nz(t, 0.18, 0.34, 'bandpass', 500, 3400, 0.9, d); tn(t, 'sawtooth', 160, 520, 0.14, 0.12, d); },
    spring: (t, d) => { tn(t, 'square', 260, 1240, 0.2, 0.16, d); tn(t, 'sine', 180, 900, 0.22, 0.2, d); },
    crumble: (t, d) => { nz(t, 0.25, 0.26, 'lowpass', 700, 180, 1, d); },
    brk: (t, d) => { nz(t, 0.28, 0.45, 'lowpass', 1900, 160, 0.8, d); tn(t, 'sine', 110, 40, 0.22, 0.4, d); },
    checkpoint: (t, d) => { [784, 988, 1175, 1568].forEach((f, i) => tn(t + i * 0.075, 'triangle', f, f, 0.22, 0.2, d)); },
    shoot: (t, d) => { tn(t, 'pulse125', 760, 280, 0.1, 0.12, d); },
    bossHit: (t, d) => { nz(t, 0.12, 0.45, 'lowpass', 3000, 240, 0.8, d); tn(t, 'square', 180, 55, 0.14, 0.28, d); tn(t, 'pulse125', 1200, 600, 0.06, 0.08, d); },
    explode: (t, d) => { nz(t, 0.5, 0.5, 'lowpass', 3200, 90, 0.7, d); tn(t, 'sine', 130, 30, 0.45, 0.5, d); },
    bigExplode: (t, d) => { nz(t, 1.4, 0.6, 'lowpass', 4000, 60, 0.6, d); tn(t, 'sine', 110, 24, 1.1, 0.6, d); nz(t + 0.1, 0.6, 0.3, 'bandpass', 900, 200, 0.8, d); },
    uiMove: (t, d) => { tn(t, 'pulse250', 620, 620, 0.035, 0.09, d); },
    uiOk: (t, d) => { tn(t, 'pulse250', 784, 784, 0.06, 0.11, d); tn(t + 0.06, 'pulse250', 1175, 1175, 0.12, 0.11, d); },
    uiBack: (t, d) => { tn(t, 'pulse250', 520, 520, 0.05, 0.1, d); tn(t + 0.05, 'pulse250', 390, 390, 0.1, 0.1, d); },
    text: (t, d, o) => { const f = 500 + ((o && o.p) || 0) * 40 + Math.random() * 50; tn(t, 'pulse250', f, f, 0.03, 0.05, d); },
    textLow: (t, d) => { const f = 130 + Math.random() * 40; tn(t, 'sawtooth', f, f * 0.9, 0.05, 0.09, d); },
    textSys: (t, d) => { const f = 880 + Math.random() * 30; tn(t, 'sine', f, f, 0.03, 0.06, d); },
    key: (t, d) => { nz(t, 0.02, 0.14, 'highpass', 2600 + Math.random() * 1500, 0, 1, d); tn(t, 'triangle', 240, 180, 0.03, 0.08, d); },
    gate: (t, d) => { [523, 659, 784, 1047, 1319, 1568].forEach((f, i) => tn(t + i * 0.06, 'pulse250', f, f, 0.2, 0.12, d)); nz(t, 0.5, 0.12, 'highpass', 5000, 0, 0.6, d); },
    agent: (t, d) => { [660, 880, 1320].forEach((f, i) => tn(t + i * 0.05, 'pulse125', f, f * 1.02, 0.09, 0.12, d)); },
    agentHit: (t, d) => { tn(t, 'pulse125', 1300, 700, 0.05, 0.08, d); nz(t, 0.04, 0.12, 'bandpass', 2400, 0, 1.2, d); },
    warn: (t, d) => { tn(t, 'square', 940, 940, 0.06, 0.1, d); tn(t + 0.1, 'square', 940, 940, 0.06, 0.1, d); },
    charge: (t, d) => { tn(t, 'sawtooth', 90, 620, 0.55, 0.12, d, 0.3); },
    laser: (t, d) => { tn(t, 'sawtooth', 1900, 170, 0.45, 0.16, d); nz(t, 0.45, 0.22, 'bandpass', 2600, 500, 2, d); },
    drip: (t, d) => { tn(t, 'sine', 1500, 620, 0.06, 0.1, d); },
    splash: (t, d) => { nz(t, 0.3, 0.3, 'bandpass', 1500, 500, 0.7, d); tn(t, 'sine', 300, 90, 0.12, 0.14, d); },
    thud: (t, d) => { tn(t, 'sine', 120, 34, 0.26, 0.6, d); nz(t, 0.18, 0.35, 'lowpass', 420, 90, 0.8, d); },
    roar: (t, d) => { nz(t, 0.9, 0.34, 'lowpass', 700, 120, 2.5, d); tn(t, 'sawtooth', 82, 46, 0.9, 0.3, d, 0.1); tn(t, 'sawtooth', 124, 61, 0.9, 0.16, d, 0.1); },
    glitch: (t, d) => { for (let i = 0; i < 6; i++) { const f = 200 + Math.random() * 2400; tn(t + i * 0.03, 'square', f, f, 0.03, 0.07, d); } },
    tick: (t, d) => { tn(t, 'sine', 1900, 1800, 0.03, 0.1, d); },
    tock: (t, d) => { tn(t, 'sine', 1250, 1200, 0.035, 0.1, d); },
    pause: (t, d) => { tn(t, 'pulse250', 660, 660, 0.06, 0.1, d); tn(t + 0.07, 'pulse250', 495, 495, 0.1, 0.1, d); },
    flap: (t, d) => { nz(t, 0.05, 0.08, 'bandpass', 900, 400, 1.5, d); },
    logo: (t, d) => { tn(t, 'sine', 80, 38, 0.5, 0.6, d); nz(t, 0.35, 0.3, 'lowpass', 900, 100, 0.8, d); [294, 440, 587, 740].forEach((f, i) => tn(t + 0.02 + i * 0.03, 'triangle', f, f, 0.9, 0.12, d)); },
    stamp: (t, d) => { tn(t, 'sine', 150, 50, 0.16, 0.5, d); nz(t, 0.06, 0.3, 'lowpass', 1600, 300, 1, d); },
  };
  // per-sound trim, set by measuring every effect offline so nothing is buried or blaring
  const TRIM = { jump: 1.7, djump: 1.6, walljump: 1.7, land: 3, swipe: 2, swipeBig: 1.9, dash: 2, text: 2.2, textLow: 1.6, textSys: 2, key: 1.6, uiMove: 2, uiBack: 1.4, shoot: 2, clang: 1.6, token: 1.2, hit: 1.2, squish: 1.2, kill: 1.2, hurt: 1.3, spring: 1.2, laser: 1.5, tick: 1.6, tock: 1.6, drip: 1.6, flap: 2, crumble: 1.6, agentHit: 1.8, explode: 0.7, bigExplode: 0.55, roar: 0.6, logo: 0.65, thud: 0.9, spark: 0.65, checkpoint: 0.65, die: 0.9, gate: 0.9, bossHit: 1.1 };
  A.sfx = (name, o) => {
    if (!ctx || ctx.state !== 'running') return;
    const fn = SFX[name];
    if (!fn) return;
    const now = ctx.currentTime;
    if (last[name] && now - last[name] < 0.028) return;
    last[name] = now;
    if (name === 'token') { tokenChain = now - tokenT < 0.5 ? tokenChain + 1 : 0; tokenT = now; }
    let dest = sfxBus;
    const k = (TRIM[name] || 1) * (o && o.vol !== undefined ? o.vol : 1);
    if (k !== 1) { dest = ctx.createGain(); dest.gain.value = k; dest.connect(sfxBus); }
    fn(now + 0.004, dest, o);
  };
  A.pauseAll = (on) => { A.paused = on; if (!ctx) return; if (on) ctx.suspend(); else if (!document.hidden) ctx.resume(); };

  // ---------- voice ----------
  // Lines are fetched and decoded into the audio graph when the page is served over http(s);
  // opened straight from disk (or if that fails) they fall back to a plain <audio> element.
  const V = (G.voice = { cur: null, cache: {}, buf: {}, pending: {}, token: 0 });
  const SRC = (id) => 'assets/voice/' + id + '.mp3';
  function loadBuf(id) {
    if (V.buf[id] || !ctx || location.protocol === 'file:') return null;
    if (!V.pending[id]) {
      V.pending[id] = fetch(SRC(id))
        .then((r) => { if (!r.ok) throw new Error('http ' + r.status); return r.arrayBuffer(); })
        .then((ab) => new Promise((res, rej) => ctx.decodeAudioData(ab, res, rej)))
        .then((b) => { V.buf[id] = b; return b; })
        .catch(() => null);
    }
    return V.pending[id];
  }
  // mute: the recording no longer matches the rewritten text, so the line shows as a subtitle only
  V.warm = (ids) => { for (const id of ids) if (G.VOICE && G.VOICE[id] && !G.VOICE[id].mute) loadBuf(id); };
  V.has = (id) => !!(G.VOICE && G.VOICE[id]);
  V.text = (id) => (G.VOICE && G.VOICE[id] ? G.VOICE[id].t : '');
  // returns how long the line lasts (so subtitles can pace themselves)
  V.play = (id) => {
    V.stop();
    const meta = G.VOICE && G.VOICE[id];
    if (!meta || meta.mute) return 0;
    const my = ++V.token;
    const done = () => { if (my === V.token) { V.cur = null; A.duck(1); } };
    const viaGraph = (b) => {
      if (my !== V.token) return;
      const s = ctx.createBufferSource();
      s.buffer = b; s.connect(voiceBus); s.onended = done; s.start();
      V.cur = { stop() { s.onended = null; try { s.stop(); } catch (e) { /* already over */ } } };
      A.duck(0.42);
    };
    const viaElement = () => {
      if (my !== V.token) return;
      try {
        const a = V.cache[id] || (V.cache[id] = new Audio(SRC(id)));
        a.currentTime = 0;
        a.volume = A.muted ? 0 : Math.min(1, G.save.data.opt.voice);
        a.onended = done;
        const pr = a.play();
        if (pr && pr.catch) pr.catch(() => {});
        V.cur = { el: a, stop() { a.onended = null; try { a.pause(); } catch (e) { /* ignore */ } } };
        A.duck(0.42);
      } catch (e) { /* no audio available - subtitles still run */ }
    };
    if (ctx && ctx.state === 'running' && V.buf[id]) viaGraph(V.buf[id]);
    else {
      const p = ctx && ctx.state === 'running' ? loadBuf(id) : null, t0 = performance.now();
      if (p) p.then((b) => { if (b && performance.now() - t0 < 1200) viaGraph(b); else if (!b) viaElement(); });
      else viaElement();
    }
    return meta.d;
  };
  V.stop = () => {
    V.token++;
    if (V.cur) { V.cur.stop(); V.cur = null; A.duck(1); }
  };
})();

